import React from 'react';
import { Flex, Toggle, Tooltip } from '@marvelapp/ui';
import SettingsItem from '../SettingsItem';
export default function SettingsToggle({ description, headingSize, isChecked, mb, onChange, testId, title, disabledTooltipText, }) {
    const isDisabled = !!disabledTooltipText;
    const toggleComponent = (React.createElement(Toggle, { checked: isChecked, "data-testid": testId, disabled: isDisabled, id: title, ml: 2, onChange: onChange, size: 42 }));
    const wrappedToggle = isDisabled ? (React.createElement(Tooltip, { content: disabledTooltipText }, toggleComponent)) : (toggleComponent);
    return (React.createElement(SettingsItem, { description: description, headingSize: headingSize, mb: mb, title: title },
        React.createElement(Flex, { alignItems: "center" }, wrappedToggle)));
}
